import { TaskNode } from './task.node';
import { Entity } from '../entity';
import { TaskLinkEntity } from './task.props.type';

import * as Enumerable from 'linq';
import { TaskLinkType } from './task.enum';
import { DateUtility } from '../../utilities/date.utility';

interface TaskLike extends Entity {
    parent?: TaskLinkEntity,
    daily?: boolean;
    instance?: boolean;
    createdAt?: Date;
}

export class TaskNodeUtility {

    public static build(tasks: TaskLike[], dateFormat: string = 'dd/MM/yyyy', timezone = 'utc'): TaskNode[] {

        const parentMap = new Map<string, TaskNode>();

        const parentIds = Enumerable
            .from(tasks)
            .where(e => !!e.parent)
            .select(e => e.parent)
            .distinct(e => e._id)
            .toArray();

        const itemsMap = Enumerable
            .from(tasks)
            .toDictionary(e => e._id, e => e);

        const rootParent = new Map<string, TaskNode>();

        // create all the parents first
        parentIds
            .forEach(e => {

                const parent = this.createTaskModel(e);
                // the root parent won't here, it is the WO, JOb or Project....

                if (!itemsMap.contains(e._id)) {
                    rootParent.set(e._id, parent);
                }

                parentMap.set(e._id, parent);
            });

        tasks.forEach(e => {
            const parent = parentMap.get(e.parent._id);

            if (e.daily && e.instance) {
                // We have an instance of a daily task
                const dateName = DateUtility.getDateTime(e.createdAt, timezone).toFormat(dateFormat);
                // const parentName = e.parent.name;;
                e.name = `${dateName}`;
            }

            //if it is a parent
            if (parentMap.has(e._id)) {
                // because the data in item has more detail. so replace the parent one with its detail
                const item = this.createTaskModel(e);
                parentMap.set(e._id, item);

                //get its parent and add it to its parent
                this.addChild(parent, parentMap.get(e._id));

                return;
            }

            this.addChild(parent, this.createTaskModel(e));
        })

        const nodes = Array.from(rootParent.values());
        return nodes;
    }

    private static createTaskModel(task: TaskLike): TaskNode {
        return {
            _id: task._id,
            name: task.name,
            taskData: task,
            children: [],
        } as TaskNode;
    }

    private static addChild(parent: TaskNode, child: TaskNode) {
        parent.children.push(child);

        // parent.children = Enumerable
        //     .from(parent.children)
        //     .orderBy(x => x.taskData?.sortOrder)
        //     .toArray();

        if (parent.taskData?.type === TaskLinkType.Item) {
            parent.hasComplianceSubtask = Enumerable.from(parent.children).any(x => x.taskData.type === TaskLinkType.Compliance)
        }

        child.parent = { ...parent, children: [] };
    }

}